import { TravellerCategory } from '../../../../models/traveller-category.enum';
import { TimeLimitation } from '../../../../models/time-limitation.enum';
import TimeValidityApiModel from './time-validity.api-model';
import { ProductInstanceType } from '../../../../models/product-instance-type.enum';
import { type ITicketSuggestion } from '../../../../models/ticket-suggestion.model';
import ChannelApiModel from './channel.api-model';

export default class TicketSuggestionApiModel {
  public static mapToBusinessModel(apiModel: TicketSuggestionApiModel): ITicketSuggestion {
    return {
      productId: apiModel.productId,
      productName: apiModel.productName,
      productType: apiModel.productType,
      travellerCategory: apiModel.travellerCategory,
      timeLimitation: apiModel.timeLimitation,
      priceInSek: apiModel.priceInSek,
      timeValidity: TimeValidityApiModel.mapToBusinessModel(apiModel.timeValidity),
      saleChannels: apiModel.saleChannels.map(ChannelApiModel.mapToBusinessModel),
      productInstanceType: apiModel.productInstanceType,
    };
  }
  productId!: number;
  productName!: string;
  productType!: number;
  travellerCategory!: TravellerCategory;
  timeLimitation!: TimeLimitation;
  priceInSek!: number;
  timeValidity!: TimeValidityApiModel;
  saleChannels!: ChannelApiModel[];
  productInstanceType!: ProductInstanceType;
}
